var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430.72 100.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-2 {\n        letter-spacing: .05em;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        font-size: 46.27px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: #d41031;\n      }\n\n      .cls-2, .cls-4 {\n        font-family: Montserrat-Bold, Montserrat;\n        font-weight: 700;\n      }\n\n      .cls-6 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-3 {\n        font-family: Montserrat-Regular, Montserrat;\n      }\n\n      .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-7 {\n        letter-spacing: .01em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sa\\u011F_En_Lat",
    "data-name": "Sa\\u011F En Lat"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(130.06 87.38) rotate(.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.48,
    y: 0
  }, "ANGIN")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(328.96 44.49) rotate(.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 27.53,
    y: 0
  }, "AN")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(126.08 42.95) rotate(.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DO\u011EAN")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 73.96 17.64 93.74 49.82 93.74 32.42 73.96 0 73.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "121.19 73.96 103.56 93.74 71.37 93.74 88.78 73.96 121.19 73.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "61.1 0 36.84 58.6 48.99 73.96 61.1 44.7 73.21 73.96 85.37 58.6 61.1 0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1b0cf4feb818972dd14da7012b0c703e.svg";
export { ForwardRef as ReactComponent };